<nav class="isa-nav">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-[68px]">

      <!-- ═══ LOGO ═══ -->
      <div class="logo-wrap flex items-center gap-3 cursor-pointer" [routerLink]="'/home'">
        <img src="assets/ISA-logo.png" alt="ISA Logo"
          style="width:46px;height:46px;object-fit:contain;border-radius:10px;"
          onerror="this.style.display='none';this.nextElementSibling.style.display='flex'">
        <!-- <div class="logo-icon" style="display:none">ISA</div> -->
        <div class="hidden sm:flex flex-col leading-none">
          <span style="font-size:1.05rem;font-weight:800;color:#0f172a;letter-spacing:-0.5px">ISA Connect</span>
          <span
            style="font-size:0.6rem;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#6366f1;margin-top:1px">INDOTECH SOFTWARE ASSOCIATION</span>
        </div>
      </div>

      <!-- ═══ DESKTOP NAV LINKS ═══ -->
      <div class="desktop-nav hidden md:flex items-center gap-1">
        <a *ngFor="let item of navItems" href="" (click)="$event.preventDefault(); onNavigate(item.path)"
          [routerLink]="item.path" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: item.path === '/home' }" class="nav-link">
          {{ item.label }}
        </a>
      </div>

      <!-- ═══ RIGHT SIDE ═══ -->
      <div class="flex items-center gap-3">

        <!-- Not logged in -->
        <ng-container *ngIf="!currentUser; else loggedInTpl">
          <button id="nav-login-btn" class="btn-login" (click)="onOpenAuth('LOGIN')">Log in</button>
          <button id="nav-register-btn" class="btn-join" (click)="onOpenAuth('REGISTER')">
            <span>Join ISA</span>
          </button>
        </ng-container>

        <!-- Logged in -->
        <ng-template #loggedInTpl>
          <!-- User Badge -->
          <div class="user-badge hidden md:flex" (click)="onDashboard()">
            <div class="avatar-ring">
              <img *ngIf="currentUser?.image" [src]="currentUser?.image" [alt]="currentUser?.name">
              <span *ngIf="!currentUser?.image" class="avatar-initials">
                {{ currentUser?.name?.charAt(0)?.toUpperCase() }}
              </span>
            </div>
            <div class="user-info">
              <span class="user-name">{{ currentUser?.name }}</span>
              <span class="user-role-pill" [class.role-premium]="currentUser?.type === 'PREMIUM'"
                [class.role-regular]="currentUser?.type === 'REGULAR'"
                [class.role-admin]="currentUser?.type === 'ADMIN' || currentUser?.role === 'admin'">
                {{ getUserPlanLabel() }}
              </span>
            </div>
          </div>

          <div class="nav-divider hidden md:block"></div>

          <!-- Logout -->
          <button id="nav-logout-btn" class="btn-logout" (click)="onLogout()" title="Sign out">
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </button>
        </ng-template>

        <!-- Mobile menu button -->
        <button class="mobile-menu-btn md:hidden">
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

      </div>
    </div>
  </div>
</nav>